import { render, staticRenderFns } from "./aPricingStrategyStrategyDetail.vue?vue&type=template&id=468b996a"
import script from "./aPricingStrategyStrategyDetail.vue?vue&type=script&lang=js"
export * from "./aPricingStrategyStrategyDetail.vue?vue&type=script&lang=js"
import style0 from "./aPricingStrategyStrategyDetail.vue?vue&type=style&index=0&id=468b996a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VBtn,VDialog,VDivider,VIcon,VSkeletonLoader})
